import {IOperatorsState} from "./OperatorsState";

export const initState: IOperatorsState = {
    operatorsList: {
        isReceivingOperators: false,
        allOperators: [],
        isSortingBeOperatorName: false
    },
}